import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useLayoutEffect, useRef } from 'react';
import _ from 'lodash';
import i18n from 'i18next';
import cx from 'classnames';
import moment from 'moment';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);
var t = i18n.getFixedT(null, 'traffic-live');
var gt = i18n.getFixedT(null, 'app');
var PredictionModel = /*#__PURE__*/React.memo(function (props) {
  var predictionData = props.predictionData,
      type = props.type,
      dateAry = props.dateAry;
  var tooltipTarget_ref = useRef(null);
  useLayoutEffect(function () {
    var chart = am4core.create('predictionChart', am4charts.XYChart); //     am4core.addLicense

    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    //     // chart.paddingTop = 40
    //     // chart.paddingRight = 40

    chart.cursor = new am4charts.XYCursor(); // Create axes

    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'time';
    categoryAxis.dataItems.template.text = '{time}';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 40; //     categoryAxis.title.text = '時間'
    //     // categoryAxis.title.align = 'right'
    //     // categoryAxis.title.dy = -30
    //     // categoryAxis.title.dx = 20

    categoryAxis.cursorTooltipEnabled = false; // y-axes

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minGridDistance = 30;
    valueAxis.min = 0;
    valueAxis.title.text = type === 'terminal' ? '輛' : '分鐘'; //     // valueAxis.title.rotation = 0
    //     // valueAxis.title.valign = 'top'
    //     // valueAxis.title.dy = -30
    //     // valueAxis.title.dx = 26

    valueAxis.cursorTooltipEnabled = false; // Set up series - lineSeries

    if (type === 'terminal') {
      // series pickup
      var series_pickUp = chart.series.push(new am4charts.LineSeries());
      series_pickUp.dataFields.categoryX = 'time';
      series_pickUp.dataFields.valueY = 'pickUpEstTrailerLineQty';
      series_pickUp.strokeWidth = 2;
      series_pickUp.name = t('lbl-pickUp');
      series_pickUp.adapter.add('tooltipText', function (text, target) {
        if (tooltipTarget_ref.current === 'return') return;
        tooltipTarget_ref.current = 'pick';
        var time = target.tooltipDataItem.dataContext.time;
        var _predictionData$targe = predictionData[target.tooltipDataItem.dataContext.key],
            pickUpItem = _predictionData$targe.pickUpItem,
            returnItem = _predictionData$targe.returnItem;
        var pickUpVehicles = _.isEmpty(pickUpItem) || parseInt(pickUpItem.avgTrailerLineQtyPrediction) === -1 ? t('lbl-no-data') : t('lbl-vehicles', {
          vehicles: _.round(pickUpItem.avgTrailerLineQtyPrediction)
        });
        var returnVehicles = _.isEmpty(returnItem) || parseInt(returnItem.avgTrailerLineQtyPrediction) === -1 ? t('lbl-no-data') : t('lbl-vehicles', {
          vehicles: _.round(returnItem.avgTrailerLineQtyPrediction)
        });
        var valueY = "".concat(t('lbl-pickUp')).concat(pickUpVehicles, "\uFF0C").concat(t('lbl-return')).concat(returnVehicles);
        target.tooltip.getFillFromObject = false;
        target.tooltip.background.fill = am4core.color("#000");
        return "".concat(time, "\n").concat(valueY);
      }); // Add simple bullet max

      var bullet_pickup_max = series_pickUp.bullets.push(new am4charts.Bullet());
      bullet_pickup_max.disabled = true;
      bullet_pickup_max.propertyFields.disabled = "isMaxPickUp";
      var circle_pickup_max = bullet_pickup_max.createChild(am4core.Circle);
      circle_pickup_max.width = 10;
      circle_pickup_max.height = 10;
      circle_pickup_max.stroke = am4core.color('#ff3c3c');
      circle_pickup_max.fill = am4core.color('#ff3c3c');
      circle_pickup_max.horizontalCenter = "middle";
      circle_pickup_max.verticalCenter = "middle"; // Add simple bullet min

      var bullet_pickup_min = series_pickUp.bullets.push(new am4charts.Bullet());
      bullet_pickup_min.disabled = true;
      bullet_pickup_min.propertyFields.disabled = "isMinPickUp";
      var circle_pickup_min = bullet_pickup_min.createChild(am4core.Circle);
      circle_pickup_min.width = 10;
      circle_pickup_min.height = 10;
      circle_pickup_min.stroke = am4core.color('#55c836');
      circle_pickup_min.fill = am4core.color('#55c836');
      circle_pickup_min.horizontalCenter = "middle";
      circle_pickup_min.verticalCenter = "middle"; // series return

      var series_return = chart.series.push(new am4charts.LineSeries());
      series_return.dataFields.categoryX = 'time';
      series_return.dataFields.valueY = 'returnEstTrailerLineQty';
      series_return.strokeWidth = 2;
      series_return.name = t('lbl-return');
      series_return.adapter.add('tooltipText', function (text, target) {
        if (tooltipTarget_ref.current === 'pick') return;
        tooltipTarget_ref.current = 'return';
        var time = target.tooltipDataItem.dataContext.time;
        var _predictionData$targe2 = predictionData[target.tooltipDataItem.dataContext.key],
            pickUpItem = _predictionData$targe2.pickUpItem,
            returnItem = _predictionData$targe2.returnItem;
        var pickUpVehicles = _.isEmpty(pickUpItem) || parseInt(pickUpItem.avgTrailerLineQtyPrediction) === -1 ? t('lbl-no-data') : t('lbl-vehicles', {
          vehicles: _.round(pickUpItem.avgTrailerLineQtyPrediction)
        });
        var returnVehicles = _.isEmpty(returnItem) || parseInt(returnItem.avgTrailerLineQtyPrediction) === -1 ? t('lbl-no-data') : t('lbl-vehicles', {
          vehicles: _.round(returnItem.avgTrailerLineQtyPrediction)
        });
        var valueY = "".concat(t('lbl-pickUp')).concat(pickUpVehicles, "\uFF0C").concat(t('lbl-return')).concat(returnVehicles);
        target.tooltip.getFillFromObject = false;
        target.tooltip.background.fill = am4core.color("#000");
        return "".concat(time, "\n").concat(valueY);
      }); // Add simple bullet max

      var bullet_return_max = series_return.bullets.push(new am4charts.Bullet());
      bullet_return_max.disabled = true;
      bullet_return_max.propertyFields.disabled = "isMaxReturn";
      var circle_return_max = bullet_return_max.createChild(am4core.Circle);
      circle_return_max.width = 10;
      circle_return_max.height = 10;
      circle_return_max.stroke = am4core.color('#ff3c3c');
      circle_return_max.fill = am4core.color('#ff3c3c');
      circle_return_max.horizontalCenter = "middle";
      circle_return_max.verticalCenter = "middle"; // Add simple bullet min

      var bullet_return_min = series_return.bullets.push(new am4charts.Bullet());
      bullet_return_min.disabled = true;
      bullet_return_min.propertyFields.disabled = "isMinReturn";
      var circle_return_min = bullet_return_min.createChild(am4core.Circle);
      circle_return_min.width = 10;
      circle_return_min.height = 10;
      circle_return_min.stroke = am4core.color('#55c836');
      circle_return_min.fill = am4core.color('#55c836');
      circle_return_min.horizontalCenter = "middle";
      circle_return_min.verticalCenter = "middle";
    } else {
      var series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.categoryX = 'time';
      series.dataFields.valueY = 'estVisitDuration';
      series.strokeWidth = 2;
      series.adapter.add('tooltipText', function (text, target) {
        var time = target.tooltipDataItem.dataContext.time;
        var item = predictionData[target.tooltipDataItem.dataContext.key];
        var valueY = _.isEmpty(item) || _.round(item.visitDurationPredictionMins) === -1 ? t('lbl-no-data') : _.round(item.visitDurationPredictionMins) + '分';
        return "".concat(time, "\n").concat(valueY);
      }); // Add simple bullet max

      var bullet_max = series.bullets.push(new am4charts.Bullet());
      bullet_max.disabled = true;
      bullet_max.propertyFields.disabled = "isMax";
      var circle_max = bullet_max.createChild(am4core.Circle);
      circle_max.width = 10;
      circle_max.height = 10;
      circle_max.stroke = am4core.color('#ff3c3c');
      circle_max.fill = am4core.color('#ff3c3c');
      circle_max.horizontalCenter = "middle";
      circle_max.verticalCenter = "middle"; // Add simple bullet min

      var bullet_min = series.bullets.push(new am4charts.Bullet());
      bullet_min.disabled = true;
      bullet_min.propertyFields.disabled = "isMin";
      var circle_min = bullet_min.createChild(am4core.Circle);
      circle_min.width = 10;
      circle_min.height = 10;
      circle_min.stroke = am4core.color('#55c836');
      circle_min.fill = am4core.color('#55c836');
      circle_min.horizontalCenter = "middle";
      circle_min.verticalCenter = "middle";
    } // Add a legend


    if (type === 'terminal') {
      chart.legend = new am4charts.Legend();
      chart.legend.position = 'right';
      chart.legend.maxWidth = '100';
      chart.legend.fontSize = '12';
    } // add range


    var range = categoryAxis.axisRanges.create();
    range.category = '00:00';
    range.text = '';
    range.grid.stroke = am4core.color('#ff3c3c');
    range.grid.strokeOpacity = 5;
    chart.data = _.map(predictionData, function (el, key) {
      var obj = {};

      if (type === 'terminal') {
        obj.pickUpEstTrailerLineQty = _.isEmpty(el.pickUpItem) || _.round(el.pickUpItem.avgTrailerLineQtyPrediction) === -1 ? 0 : _.round(el.pickUpItem.avgTrailerLineQtyPrediction);
        obj.isMaxPickUp = !_.isEmpty(el.pickUpItem) && el.pickUpItem.isMax ? false : true;
        obj.isMinPickUp = !_.isEmpty(el.pickUpItem) && el.pickUpItem.isMin ? false : true;
        obj.returnEstTrailerLineQty = _.isEmpty(el.returnItem) || _.round(el.returnItem.avgTrailerLineQtyPrediction) === -1 ? 0 : _.round(el.returnItem.avgTrailerLineQtyPrediction);
        obj.isMaxReturn = !_.isEmpty(el.returnItem) && el.returnItem.isMax ? false : true;
        obj.isMinReturn = !_.isEmpty(el.returnItem) && el.returnItem.isMin ? false : true;
      } else {
        obj.estVisitDuration = _.isEmpty(el) || _.round(el.visitDurationPredictionMins) === -1 ? 0 : _.round(el.visitDurationPredictionMins);
        obj.isMax = !_.isEmpty(el) && el.isMax ? false : true;
        obj.isMin = !_.isEmpty(el) && el.isMin ? false : true;
      }

      return _objectSpread({
        key: key,
        time: moment(parseInt(key)).format('HH:mm')
      }, obj);
    }); // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chart.dispose();
    };
  }, [JSON.stringify(predictionData)]);

  var calCongestionStatus = function calCongestionStatus(val) {
    if (val === 1) return 'low';
    if (val === 2) return 'middle';
    if (val === 3) return 'high';
  };

  var renderList = function renderList() {
    return _.map(predictionData, function (el, key) {
      var predictResult = '';

      if (type === 'terminal') {
        var returnItem = el.returnItem,
            pickUpItem = el.pickUpItem;
        var pickUpVehicles = pickUpItem && Number(pickUpItem.avgTrailerLineQtyPrediction) > -1 ? t('lbl-vehicles', {
          vehicles: _.round(pickUpItem.avgTrailerLineQtyPrediction)
        }) : t('lbl-no-data');
        var returnVehicles = returnItem && Number(returnItem.avgTrailerLineQtyPrediction) > -1 ? t('lbl-vehicles', {
          vehicles: _.round(returnItem.avgTrailerLineQtyPrediction)
        }) : t('lbl-no-data');
        predictResult = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
          className: cx('return-vehicles status', calCongestionStatus(returnItem.congestionStatus))
        }, "".concat(t('lbl-return')).concat(returnVehicles)), /*#__PURE__*/React.createElement("span", {
          className: cx('pickup-vehicles status', calCongestionStatus(pickUpItem.congestionStatus))
        }, "".concat(t('lbl-pickUp')).concat(pickUpVehicles)));
      } else {
        var hourText = '',
            minText = t('lbl-minutes', {
          minutes: _.round(el.visitDurationPredictionMins)
        });

        if (el && el.visitDurationPredictionMins > 60) {
          var minute = _.round(el.visitDurationPredictionMins);

          hourText = t('lbl-hours', {
            hours: parseInt(minute / 60)
          });
          minText = t('lbl-minutes', {
            minutes: parseInt(minute % 60)
          });
        }

        predictResult = /*#__PURE__*/React.createElement("span", {
          className: cx('prediction-time status', calCongestionStatus(el.congestionStatus))
        }, _.isEmpty(el) ? t('lbl-no-data') : "".concat(t('lbl-prediction-time', {
          times: hourText + minText
        })));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "item",
        key: key
      }, /*#__PURE__*/React.createElement("p", null, moment(parseInt(key)).format('YYYY-MM-DD')), /*#__PURE__*/React.createElement("p", null, moment(parseInt(key)).format('HH:mm')), /*#__PURE__*/React.createElement("p", {
        className: "number"
      }, predictResult));
    });
  };

  var renderDate = function renderDate() {
    return dateAry.map(function (el, index) {
      var daysTextAry = ['日', '一', '二', '三', '四', '五', '六'];
      var day = daysTextAry[new Date(el).getDay()];
      return /*#__PURE__*/React.createElement("span", {
        key: "chart-date-".concat(index),
        className: "date-".concat(index)
      }, "".concat(el, "(").concat(day, ")"));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, type === 'terminal' ? t('lbl-termanal-prediction-title') : t('lbl-gates-prediction-title')), /*#__PURE__*/React.createElement("div", {
    className: cx('chart-date', type, {
      'two': dateAry.length == 2
    })
  }, renderDate()), /*#__PURE__*/React.createElement("div", {
    id: "predictionChart",
    onMouseLeave: function onMouseLeave() {
      return tooltipTarget_ref.current = null;
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "prediction-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("p", {
    className: "date"
  }, t('lbl-date')), /*#__PURE__*/React.createElement("p", null, t('lbl-time')), /*#__PURE__*/React.createElement("p", {
    className: "count"
  }, type === 'terminal' ? t('lbl-prediction-car-count') : t('lbl-prediction-inout-time'))), /*#__PURE__*/React.createElement("div", {
    className: "list-content"
  }, renderList())));
});
export default PredictionModel;